import { QueryClient } from '@tanstack/react-query';
import { GENERATED_REPORTS_QUERY_KEY } from '@core/hooks/useGeneratedReports';
import { STUDY_REPORT_PDF_QUERY_KEY, STUDY_REPORTS_QUERY_KEY } from 'app/features/reports/view';
import { GET_PEDING_REPORTS_QUERY_KEY } from '../hooks/useGetPendingReports';
import { GET_STUDY_REPORTS_CREATED_BY_USER_QUERY_KEY } from '../hooks/useGetReportsCreatedByUser';

/**
 * After a report of the study is saved, edited or deleted: refetch the report
 * list / PDFs and the lists that drive the report actions (those are keyed
 * without the study, there is only one open at a time).
 */
const invalidateStudyReportQueries = (queryClient: QueryClient) =>
  Promise.all(
    [
      STUDY_REPORTS_QUERY_KEY,
      STUDY_REPORT_PDF_QUERY_KEY,
      GENERATED_REPORTS_QUERY_KEY,
      GET_STUDY_REPORTS_CREATED_BY_USER_QUERY_KEY,
      GET_PEDING_REPORTS_QUERY_KEY,
    ].map((key) => queryClient.invalidateQueries([key])),
  );

export default invalidateStudyReportQueries;
